<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="450"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="wrapper-form-crud overflow-y-auto">
            <h3>{{ formItem.name }}</h3>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-card-title class="pt-1 pb-2">
                                <v-switch 
                                    v-model="formItem.is_bonus" 
                                    class="mt-0" 
                                    label="BONIFICACIÓN"
                                    hide-details
                                    :false-value="false"
                                    :true-value="true"
                                    @change="handleChangeBonus"
                                ></v-switch>
                            </v-card-title>                            
                        </v-card>
                    </v-col>
                </v-row>
                <v-row v-if="formItem.type_product === 'standar'">
                    <v-col cols="12" class="pt-1 pb-1">
                        <v-card>
                            <v-card-title class="pt-1 pb-1">
                                <span class="subtitle-2">Precios</span>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <label>Seleccione precio</label>
                                <v-radio-group class="mt-0" v-model="formItem.base_price">
                                    <v-radio 
                                        :label="`P. unitario: ${formItem.unit_price}`" 
                                        :value="formItem.unit_price">
                                    </v-radio>
                                    <v-radio 
                                        :label="`P. por mayor: ${formItem.wholesale_price}`" 
                                        :value="formItem.wholesale_price">
                                    </v-radio>
                                    <v-radio 
                                        :label="`P. preferencia: ${formItem.preferential_price}`" 
                                        :value="formItem.preferential_price">
                                    </v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pt-1 pb-1">
                        <v-card>
                            <v-card-title class="pt-1 pb-1">
                                <span class="subtitle-2">Descuento</span>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text class="pb-1">
                                <v-btn-toggle
                                    v-model="formItem.discount_type"
                                    mandatory
                                    dense
                                    color="green darken-3"
                                    class="mr-3">
                                    <v-btn value="Monto" class="btn-show-mode">
                                        S/ 
                                    </v-btn>
                                    <v-btn value="Porcentaje" class="btn-show-mode">
                                        %
                                    </v-btn>
                                </v-btn-toggle>
                                <v-text-field 
                                    :label="`${formItem.discount_type} a descontar`" 
                                    class="field-discount" 
                                    v-model="formItem.discount_amount"
                                    outlined
                                    dense
                                    type="number"
                                    :readonly="formItem.is_bonus"
                                ></v-text-field>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row v-if="formItem.type_product === 'custom'">
                    <v-col cols="12" class="pt-1 pb-1">
                        <v-card>
                            <v-card-title class="pt-1 pb-1">
                                <span class="subtitle-2">Detalle</span>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-textarea
                                    v-model="formItem.description"
                                    outlined
                                    label="Detalles"
                                    hide-details
                                    rows="6"
                                >
                                </v-textarea>
                            </v-card-text>
                        </v-card>

                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-btn color="error" 
                            block
                            outlined 
                            @click="closeDrawer()" 
                            :elevation="10">
                            Cancelar
                        </v-btn>
                        
                    </v-col>
                    <v-col cols="6">
                        <v-btn color="primary" 
                            block
                            raised 
                            @click="saveSetting()" 
                            :elevation="10">
                            Guardar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
            
        </div>
    </v-navigation-drawer>
    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import CartTools from '../../helpers/CartTools';

export default {
    name: 'SettingItem',
    computed: {
        ...mapState('sales', [
            'itemSelected'
        ])
    },
    data() {
        return {
            drawer: false,
            titleForm: '',
            current_price: null,
            formItem: {
                id: null,
                name: null,
                unit_price: null, 
                wholesale_price: null,
                preferential_price: null,
                base_price: null,
                price: null,
                discount_type: null,
                discount_amount: null,
                discount_value: null,               
                quantity: null,
                has_return: null,
                description: null,
                type_product: null,
                is_bonus: false
            }
        }
    },
    methods: {
        ...mapMutations('sales', [
            'setShowProduct',
            'setProduct',
            'setItemSelected'    
        ]),
        ...mapActions('sales', [
            'settingProduct',
            'runSetItemSelected'
        ]),
        clearForm() {
            this.formItem.id = null
            this.formItem.name = null
            this.formItem.unit_price = null
            this.formItem.wholesale_price = null
            this.formItem.preferential_price = null
            this.formItem.base_price = null
            this.formItem.price = null
            this.formItem.discount_type = null
            this.formItem.discount_amount = null
            this.formItem.discount_value = null
            this.formItem.quantity = null
            this.formItem.has_return = null
            this.formItem.description = null;
            this.formItem.type_product = null;
            this.formItem.is_bonus = false;
        },
        showForm(title) {
            this.titleForm = title
            this.clearForm()
            this.setValueToForm(this.itemSelected)
            this.drawer = !this.drawer
        },
        setValueToForm(item) {
            this.formItem.id = item.id
            this.formItem.name = item.name
            this.formItem.unit_price = item.unit_price
            this.formItem.wholesale_price = item.wholesale_price
            this.formItem.preferential_price = item.preferential_price
            this.formItem.base_price = item.base_price
            this.formItem.price = item.price
            this.formItem.discount_type = item.discount_type
            this.formItem.discount_amount = item.discount_amount
            this.formItem.discount_value = item.discount_value
            this.formItem.quantity = item.quantity
            this.formItem.has_return = item.has_return
            this.formItem.description = item.description;
            this.formItem.type_product = item.type_product;
            this.formItem.is_bonus = item.is_bonus;

            this.current_price = item.base_price;            
        },
        closeDrawer() {
            this.drawer = false
        },
        saveSetting() {
            let messageValidation = this.validateDiscount(this.formItem.discount_amount);
            if (messageValidation == 'success') {
                let discount_value = CartTools.calculateDiscountValueItem(this.formItem);
                this.formItem.discount_value = discount_value;
                let total_original = parseFloat(this.formItem.quantity) * parseFloat(this.formItem.base_price);
                let total_with_discount = total_original - this.formItem.discount_value;
                if (total_with_discount <= 0) {
                    this.$swal({
                        text: "El descuento debe ser menor al total del item",
                        icon: "error",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Aceptar"
                    });
                } else {
                    this.runSetItemSelected(this.formItem)
                    this.settingProduct()
                    this.drawer = false
                } 
            } else {
                this.$swal({
                        text: messageValidation,
                        icon: "error",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Aceptar"
                    });
            }
                       
        },
        validateDiscount (discount = null) {
            let message = 'success';
            if (discount) {
                if (parseFloat(discount) < 0) {
                    message = 'El descuento debe ser mayor a 0';
                }
            }

            return message;
        },
        handleChangeBonus (value) {
            if (value == true) {
                this.formItem.discount_amount = 0;
            }
        }
    }
}
</script>

<style scoped>
.btn-show-mode{
    min-width: 50px !important;
}
</style>